import clsx from 'clsx';

type SliderProps = {
  onChange?: (value: number) => void;
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
};

export default function Slider({
  onChange,
  value,
  min,
  max,
  disabled
}: SliderProps) {
  const classes = clsx(
    'slider',
    disabled ? 'opacity-[70%] cursor-not-allowed' : 'cursor-pointer'
  );

  return (
    <input
      className={classes}
      type='range'
      min={min}
      max={max}
      value={value}
      onChange={onChange ? (e) => onChange(e.target.valueAsNumber) : undefined}
    />
  );
}
